import React from 'react';

const DefinitionMapper = (key) => {
  switch (key) {
    case 'upgradeInformation':
      return (
        <p>
          Some spillways do not have sufficient capacity based on the 'acceptable flood capacity' to safely release floodwaters from extreme flood events. Acceptable flood capacity can be assessed against a set of standards to give either a capacity percentage or an assessed risk (which results in a tolerance rating of acceptable or unacceptable).
          <br />
          <br />
          Dams with an acceptable flood capacity of less than 100 percent or an unacceptable tolerance rating need to be upgraded. Owners are due to complete the next stage of upgrades by either 2025 or 2035. Dams with no upgrade date have already been upgraded or do not require upgrades.

        </p>
      );
    case 'damSafety':
      return (
        <p>
          The Department of Regional Development, Manufacturing and Water's Dam safety management guidelines sets the consequence categories for dam safety and Guideline for failure impact assessment of water dams sets the criteria and assessment for failure impact ratings.
          <br />
          <br />
          Each dam's emergency action plan outlines the protocols and procedures for the dam owner and disaster management groups to manage and minimise the consequences of dam emergency events and coordinate emergency responses and warnings. It includes inundation maps showing the timing (hours) of downstream flooding in the event of a dam failure.
          <br />
          <br />
          The Department of Regional Development, Manufacturing and Water conducts dam site audits of owners' compliance with the safety standards.
        </p>
      );
    case 'storage':
      return (
        <p>
          Full supply level measures the height of water in meters against the dam wall and determines the volume of water in the reservoir (Megalitres). It is the approved water storage level of the dam for drinking and/or irrigation purposes. 
          <br />
          <br />
          The current volume excludes the dead storage volume (volume below the lowest outlet valve) that cannot be accessed under normal operating conditions.
          <br />
          <br />
          Ungated dams are designed so that excess water flows safety over the top of the wall if inflows cause the water level to rise above the full supply level.
          <br />
          <br />
          Gated dams allow owners to make controlled releases for either flood mitigation or to protect the safety of the dam if inflows cause the water level to rise above the approved full supply level. The full supply level may be reduced temporarily while upgrades are scoped, designed and until construction is completed (this is referred to as 'reduced full supply').
        </p>
      );
    case 'construction':
      return (
        <p>
          There are four main types of dams in Queensland: arch, embankment, gravity and reinforced concrete wall. They are built from a range of materials including earth, rock and concrete.
          <br />
          <br />
          A spillway is a channel or gate that discharges water from a dam. Water may flow away over the top of the dam wall (drop and OG spillways); be carried away by channels, tunnels or troughs; or be drained through pipes or a shaft (shaft and siphon spillways).
        </p>
      );
    default:
      return '';
  }
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js